import { DeprecatedDatePicker } from "common/form/inputs/datepicker";
import { DeprecatedFieldWrapper } from "common/form/enhancers/redux_form_field_wrapper";

/** @deprecated - please use components in common/core/form */
export const DeprecatedDatePickerField = DeprecatedFieldWrapper(DeprecatedDatePicker);
